import type { SportProfile } from '@/types'

export const volleyball: SportProfile = {
  id: 'volleyball',
  sport: 'volleyball',
  gender: 'coed',
  environment: 'court',
  label: 'Volleyball',
  emoji: '🏐',
  playersOnField: 6,
  contactLevel: 'none',
  hasShotClock: false,
  // Sets go to 25 pts (best of 3 or 5); durationMinutes is approximate
  periods: { label: 'Set', count: 5, durationMinutes: 25 },
  positions: [
    { key: 'outside_hitter',        label: 'Outside Hitter',        shortLabel: 'OH' },
    { key: 'middle_blocker',        label: 'Middle Blocker',         shortLabel: 'MB' },
    { key: 'right_side',            label: 'Right Side',             shortLabel: 'RS' },
    { key: 'setter',                label: 'Setter',                 shortLabel: 'S'  },
    { key: 'libero',                label: 'Libero',                 shortLabel: 'L'  },
    { key: 'defensive_specialist',  label: 'Defensive Specialist',   shortLabel: 'DS' },
  ],
  stats: [
    { key: 'kill',            label: 'Kill',              shortLabel: 'K'   },
    { key: 'assist',          label: 'Assist',             shortLabel: 'AST' },
    { key: 'ace',             label: 'Ace',                shortLabel: 'ACE' },
    { key: 'dig',             label: 'Dig',                shortLabel: 'DG'  },
    { key: 'block_solo',      label: 'Block (Solo)',        shortLabel: 'BS'  },
    { key: 'block_assist',    label: 'Block (Assist)',      shortLabel: 'BA'  },
    { key: 'error',           label: 'Attack Error',        shortLabel: 'ERR' },
    { key: 'serve_error',     label: 'Service Error',       shortLabel: 'SE'  },
    { key: 'reception_error', label: 'Reception Error',     shortLabel: 'RE'  },
  ],
}
